import { render, staticRenderFns } from "./TdDeliveryDifference.vue?vue&type=template&id=45936346&"
import script from "./TdDeliveryDifference.vue?vue&type=script&lang=ts&"
export * from "./TdDeliveryDifference.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports